// @ts-check

/**
 * @typedef SearchProps
 * @prop {string} value
 * @prop {(value: string) => void} onChange
 *
 * @param {SearchProps} props
 */
export default function Search(props) {
    return (
        <div className='search'>
            <input
                type='text'
                placeholder='Search'
                value={props.value}
                onChange={(e) => props.onChange(e.target.value)}
            />
        </div>
    );
}
